/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Component,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';
import { User } from '../../../../../models/User';

@Component({
  selector: 'app-ctv-app-details',
  templateUrl: './ctv-app-details.component.html',
  styleUrls: ['./ctv-app-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CtvAppDetailsComponent implements OnChanges {
  @Input() data: any;
  @Input() device: string;
  @Input() isFollowing: boolean;
  @Input() isFreemium: boolean;
  @Output() goToDiscovery: EventEmitter<any> = new EventEmitter<any>();
  @Output() followClick: EventEmitter<any> = new EventEmitter<any>();
  showMore: boolean;
  bundleIds: Array<any>;

  constructor(public _userService: User) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.bundleIds = JSON.parse(
        JSON.stringify(this.data['appInfo']['bundleIds'])
      );
      if (this.isFreemium) {
        this.bundleIds = this.bundleIds.slice(0, 1);
      }
    }
  }

  toAppDiscoveryClick(details: any) {
    this.goToDiscovery.emit(details);
  }

  follow(): void {
    this.followClick.emit(true);
  }
}
